import React, { useState } from "react";
import "./ContactForm.scss";
import { supabase } from "../../supabaseClient";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [formMessage, setFormMessage] = useState("");
  const [formError, setFormError] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFormMessage("");
    setFormError("");

    const { error } = await supabase.from("messages").insert([
      {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      },
    ]);

    if (error) {
      setFormError(
        "Mesajınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin."
      );
      console.error(error);
    } else {
      setFormMessage(
        "Mesajınız için teşekkür ederiz! En kısa sürede size geri döneceğiz."
      );
      setFormData({ name: "", email: "", message: "" }); // Formu temizle
    }
    setLoading(false);
  };

  return (
    <div className="contact-form-wrapper">
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Ad Soyad</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Adınız ve Soyadınız"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-Mail Adresiniz</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="ornek@mail.com"
              required
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="message">Mesajınız</label>
          <textarea
            id="message"
            value={formData.message}
            onChange={handleChange}
            rows="6"
            placeholder="Mesajınızı buraya yazın..."
            required
          ></textarea>
        </div>
        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Gönderiliyor..." : "Gönder"}
          </button>
        </div>
        {formMessage && <p className="form-message success">{formMessage}</p>}
        {formError && <p className="form-message error">{formError}</p>}
      </form>
    </div>
  );
};

export default ContactForm;
